import React from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import '../../styles/core.scss';
import css from './index.scss';

const TabButton = ({ name, route }) => {
    const linkName = `/${route.toLowerCase()}`;
    return (<NavLink
        activeClassName={css.highlight}
        className={css.tabButtonComponent}
        exact
        to={{ pathname: linkName }}
    >{name}
    </NavLink>);
};

TabButton.propTypes = {
    name: PropTypes.string,
    route: PropTypes.string
};

export default styleable(css)(TabButton);



// WEBPACK FOOTER //
// ./app/components/tab-button/index.js